<template>
	<v-dialog v-model="dialog" max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="#1A237E" class="text-lowercase" dark small v-on="on">add trademark</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title class="pt-6">
				<span class="subtitle-2">New trademark & model parameters 
				</span>
			</v-card-title>
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#1A237E"
								label="trademark"
								v-model="trademark"
								name="trademark"
								type="text"
								:rules="requiredRules">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#1A237E"
								label="model name"
								v-model="name"
								name="name"
								type="text"
								:rules="requiredRules">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field
								color="#1A237E"
								label="material"
								v-model.number="material"
								name="material"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="manufacturing"
								v-model.number="manufacturing"
								name="manufacturing"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense 
								class="text-left"
								v-model="designType"
								:items="items"
								color="#1A237E"
								item-color="grey"
								label="design type"
								:rules="requiredRules"
								@change="onceMore()">
							</v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense 
								v-model="advancedFeature"
								:items="features"
								:clearable=true
								color="#1A237E"
								item-color="grey"
								label="advanced feature"
								@change="onceMore()">
							</v-select>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="#1A237E"
								label="design level"
								v-model.number="designLevel"
								name="design"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-select dense 
								v-model="variations"
								:items="variationItems"
								:clearable=true
								color="#1A237E"
								item-color="grey"
								label="variations"
								@change="onceMore()">
							</v-select>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="mx-2 error">{{error}}</v-row>
				<v-row justify="center" class="text-no-wrap mx-2">{{message}}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="#1A237E" text
					class="text-capitalize" 
					@click="closeDialog"> 
					Close
				</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:loading="loading" 
					:disabled="!valid || loading || calculating"
					@click="calculate"
				>Calculate</v-btn>
				<v-btn color="#1A237E" text
					class="text-capitalize"
					:disabled="!calculating || Boolean(error)"
					@click="addBrand"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-xs-center">
			<loader></loader>
		</div>
	</v-dialog>
</template>

<script>
	import numeral from 'numeral'
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['gameId', 'round', 'company'],
		data () {
			return	{
				dialog: false,
				valid: false,
				message: '',
				error: '',
				calculating: false,
				trademark: '',
				requiredRules: [v => !!v || 'this field is required'],
				numberRules: [
					v => !!v || 'this field is required',
					v => /^[+]?[1-5]/.test(v) || 'it\'s expected number from 1 to 5'
				],
				name: '',
				material: '',
				manufacturing: '',
				designType: '',
				advancedFeature: '',
				designLevel: 1,
				variations: '',
				items: ['classic', 'business', 'casual', 'innovative', 'art'],
				variationItems: [1, 2, 3, 4, 5],
				brand: {}
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			advancedFeatures () {
				return this.$store.getters.advancedFeatures
			},
			unitCost () {
				return this.$store.getters.unitCost
			},
			rdInvestments () {
				return this.$store.getters.rdInvestments
			},
			rdTime () {
				return this.$store.getters.rdTime
			}, 
			currentYear () {
				return this.$store.getters.currentYear
			},
			features () {
				const arr = []
				this.advancedFeatures.forEach(item => {
					arr.push(item.text)
				})
				return arr
			}
		},
		methods: {
			getDate (months) {
				let year = this.currentYear
				let mon = '';

				if (months > 11) {
					year+= Math.trunc(months / 12)
					months = months % 12
				}
				switch (months) {
					case 2: mon = 'February'; break;
					case 3: mon = 'March'; break;
					case 4: mon = 'April'; break;
					case 5: mon = 'May'; break;
					case 6: mon = 'June'; break;
					case 7: mon = 'July'; break;
					case 8: mon = 'August'; break;
					case 9: mon = 'September'; break;
					case 10: mon = 'Oktober'; break;
					case 11: mon = 'November'; break;
					case 12: mon = 'December'; break;
					default: mon = 'January'; 
				}
				return {year: year, months: months, monName: mon}
			},
			calculate () {
				this.calculating = true	
				if(this.$refs.form.validate()) {
				/* new model parameters 
					@unitCost
					@r&dInvestments
					@r&dTime (completion)
				*/
					let afUnitCost = 0
					let afInvestments = 0
					let afTime = 0
					//
					if (this.advancedFeature) {
						const adFeature = this.advancedFeatures.find( item => item.text == this.advancedFeature.trim())
							
						afUnitCost = adFeature.unitCost
						afInvestments = adFeature.investments
						afTime = adFeature.time

						this.brand.advancedFeature = this.advancedFeature
					}

					//calculate 
					this.brand.unitCost = parseFloat((this.unitCost[this.material - 1].material +
					this.unitCost[this.manufacturing - 1].manufacturing +
					this.unitCost[this.manufacturing - 1].manufacturing * 0.2 * this.variations +
					afUnitCost).toFixed(1))

					let design = this.rdInvestments[this.designLevel - 1].designLevel ;

					this.brand.investments = this.rdInvestments[this.material - 1].material +
					design + design * this.variations * 0.2 +
					this.rdInvestments[this.manufacturing - 1].manufacturing + afInvestments;

					design = this.rdTime[this.designLevel - 1].designLevel;

					//if round === 0 => available from 1 month
					if (this.round == 0) {
						this.brand.availablefrom = 1
						this.brand.investments = 0
					}

					else {
						this.brand.availablefrom = this.rdTime[this.material - 1].material +
						design + 0.5 * this.variations +
						this.rdTime[this.manufacturing - 1].manufacturing + afTime

						if (!Number.isInteger(this.brand.availablefrom)) {
							//отсекаем целую часть месяца 
							this.brand.availablefrom = Math.trunc(this.brand.availablefrom)
						}
				
						this.brand.availablefrom+= 1
					}
					
					const date = this.getDate(this.brand.availablefrom);

					this.message = `Model will be available from ${date.monName} ${date.year}.
					Investments = $${numeral(this.brand.investments).format('0,0[.]0')}.
					Unit costs = $${this.brand.unitCost}`
				}		
			},
			onceMore () {
				this.calculating = false
			},
			async addBrand () {

				this.brand.trademark = this.trademark
				this.brand.model = this.trademark + " - " + this.name
				this.brand.material = this.material
				this.brand.manufacturing = this.manufacturing
				this.brand.designType = this.designType
				this.brand.designLevel = this.designLevel
				this.brand.variations = this.variations
				this.brand.availabletill = 12
				
				//console.log(this.brand)
				try {
					//addBrand
					await this.$store.dispatch('addBrand', {
						gameId: this.gameId,
						round: this.round,
						company: this.company,
						brand: this.brand
					})
				
					this.closeDialog ()
				}			
				catch (error) {
					this.error = error.message
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.calculating = false
				this.message = ''
				this.error = ''
				this.model={}
			}
		}
	}
</script>
<style>
	.error{
		color: white
	}
</style>